import { take, takeLatest } from "redux-saga/effects";
import { Action } from "../../App/Themes/actions";
import * as actions from "../../App/Themes/actions";
import * as sagas from "../../App/Themes/actions/sagas";

export function* watchAddNewTheme() {
  yield takeLatest(
    Action.ADD_NEW_THEME,
    sagas.addNewTheme({
      onFailure: actions.handleAddNewThemeFailure,
      onSuccess: actions.handleAddNewThemeSuccess,
    })
  );
}

export function* watchDeleteTheme() {
  yield takeLatest(
    Action.DELETE_THEME,
    sagas.deleteTheme({
      onFailure: actions.handleDeleteThemeFailure,
      onSuccess: actions.handleDeleteThemeSuccess,
    })
  );
}

export function* watchMount() {
  yield takeLatest(
    Action.MOUNT,
    sagas.fetchEditableThemes({
      onFailure: actions.handleFetchEditableThemesFailure,
      onSuccess: actions.handleFetchEditableThemesSuccess,
    })
  );
}

export function* watchUnmount() {
  yield take(Action.UNMOUNT);
}
